import React, { useEffect, useState } from "react";
import api from "@/lib/api";
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

export default function FAQPage() {
  const [faqs, setFaqs] = useState([]);
  useEffect(() => { api.get("/faqs").then((r) => setFaqs(r.data)).catch(() => {}); }, []);
  return (
    <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-14" data-testid="faq-page">
      <div className="eyebrow">FAQ</div>
      <h1 className="font-heading text-4xl sm:text-5xl font-bold text-[#0A192F] mt-3">Frequently asked questions</h1>
      <Accordion type="single" collapsible className="mt-8">
        {faqs.map((f) => (
          <AccordionItem key={f.id} value={f.id} className="border-slate-200">
            <AccordionTrigger className="text-left font-semibold text-[#0A192F] hover:no-underline hover:text-[#FF6D00]">{f.question}</AccordionTrigger>
            <AccordionContent className="text-slate-600">{f.answer}</AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>
    </div>
  );
}
